module.exports = __webpack_public_path__ + "h5/img/message.df3ecf37.png";